import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrders = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 0C0.906937 0 0 0.906937 0 2V16C0 17.0931 0.906937 18 2 18H16C17.0931 18 18 17.0931 18 16V2C18 0.906937 17.0931 0 16 0H2ZM2 4H16V16H2V4ZM4.5 7C4.224 7 4 7.224 4 7.5V8.5C4 8.776 4.224 9 4.5 9H5.5C5.776 9 6 8.776 6 8.5V7.5C6 7.224 5.776 7 5.5 7H4.5ZM8.5 7C8.224 7 8 7.224 8 7.5V8.5C8 8.776 8.224 9 8.5 9H13.5C13.776 9 14 8.776 14 8.5V7.5C14 7.224 13.776 7 13.5 7H8.5ZM4.5 11C4.224 11 4 11.224 4 11.5V12.5C4 12.776 4.224 13 4.5 13H5.5C5.776 13 6 12.776 6 12.5V11.5C6 11.224 5.776 11 5.5 11H4.5ZM8.5 11C8.224 11 8 11.224 8 11.5V12.5C8 12.776 8.224 13 8.5 13H13.5C13.776 13 14 12.776 14 12.5V11.5C14 11.224 13.776 11 13.5 11H8.5Z",
		fill: "white",
		fillOpacity: .88
	})]
});
const ForwardRef = forwardRef(SvgOrders);
export { ForwardRef as ReactComponent };
